// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__XtjgT","row":"styles_row__1RGN6"};